import { render, staticRenderFns } from "./GeneralDetails.vue?vue&type=template&id=681c44d4&scoped=true&"
import script from "./GeneralDetails.vue?vue&type=script&lang=js&"
export * from "./GeneralDetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/form.css?vue&type=style&index=0&id=681c44d4&prod&scoped=true&lang=css&"
import style1 from "./GeneralDetails.vue?vue&type=style&index=1&id=681c44d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c44d4",
  null
  
)

export default component.exports